// src/components/LoginPage.js
import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "./LoginPage.css";
import {Form, Button, Card, Container, Alert} from "react-bootstrap";
import { useAuth } from "./AuthContext";
import {SERVER_BASE_URL} from "../Constants";

const LoginPage = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const { login } = useAuth();

    useEffect(() => {
        document.title = "Login";
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(SERVER_BASE_URL + 'api/users/login', {
                username: email,
                password,
            });

            console.log(response);

            // Handle successful response
            if (response.status === 200) {
                setErrorMessage("");
                login(response.data.token, response.data.user.role);
                // Redirect to the dashboard
                navigate('/profile');
            } else {
                setErrorMessage(response.data.message || 'Login failed. Please try again.');
            }
        } catch (err) {
            // Handle API errors
            console.log(err);
            setErrorMessage(err.response?.data?.message || 'An error occurred during login.');
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Card style={{ width: "22rem" }} className="p-4 shadow">
                <Card.Title className="text-center">Login</Card.Title>

                {errorMessage && (
                    <Alert variant="danger" onClose={() => setErrorMessage("")} dismissible>
                        {errorMessage}
                    </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                    {/* Email Input */}
                    <Form.Group className="mb-1">
                        <Form.Label column="md">Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Password Input */}
                    <Form.Group className="mb-3">
                        <Form.Label column="md">Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <div className="mt-2 text-end">
                        <small>
                            <a href="/forgot-password">Forgot Password?</a>
                        </small>
                        </div>
                    </Form.Group>
                    {/* Forgot Password Link */}




                    {/* Submit Button */}
                    <Button variant="outline-primary" type="submit" className="w-100">
                        Login
                    </Button>

                    {/* Register Link */}
                    <div className="mt-3 text-center">
                        <small>
                            Don't have an account? <a href="/register">Register</a>
                        </small>
                    </div>
                </Form>
            </Card>
        </Container>
    );
}

export default LoginPage;
